/* eStylish — cart, variants, predictive search */
(function () {
  'use strict';
  var routes = window.routes || {};

  function money(cents) {
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents)
      : '₹' + (cents / 100).toFixed(2);
  }

  /* ---- Cart drawer refresh ---- */
  function openCartDrawer() {
    var d = document.getElementById('CartDrawer');
    if (d) { d.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  }
  function closeCartDrawer() {
    var d = document.getElementById('CartDrawer');
    if (d) { d.classList.remove('is-open'); document.body.style.overflow = ''; }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCartDrawer(); refreshCart(); }
    if (e.target.closest('[data-cart-close]')) { closeCartDrawer(); }
  });

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = count; el.hidden = count === 0;
    });
  }

  function refreshCart() {
    fetch(routes.cart_url + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawerContents');
        var target = document.getElementById('CartDrawerContents');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
      }).catch(function () {});
  }

  /* ---- AJAX add to cart ---- */
  function addToCart(form, btn) {
    var data = new FormData(form);
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript' },
      body: data
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch(routes.cart_url + '.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        refreshCart();
        openCartDrawer();
      })
      .catch(function () { alert(window.cartStrings ? window.cartStrings.error : 'Error'); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-add-to-cart]');
    if (form) { e.preventDefault(); addToCart(form, form.querySelector('[type=submit]')); }
  });

  /* ---- Cart quantity / remove ---- */
  function changeLine(line, qty) {
    fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartCount(cart.item_count); refreshCart(); if (document.body.classList.contains('template-cart')) location.reload(); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-change]');
    if (!b) return;
    var line = b.dataset.line, qty = parseInt(b.dataset.qty, 10);
    changeLine(line, qty);
  });

  /* ---- Product variants ---- */
  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-variants]').textContent);
    var selected = {};
    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var atc = root.querySelector('[data-atc-btn]');

    root.querySelectorAll('.variant-options').forEach(function (grp) {
      var pos = grp.dataset.optionPosition;
      var pre = grp.querySelector('[aria-pressed="true"]');
      if (pre) selected[pos] = pre.dataset.value;
      grp.addEventListener('click', function (e) {
        var btn = e.target.closest('button'); if (!btn) return;
        grp.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        selected[pos] = btn.dataset.value;
        resolve();
      });
    });

    function resolve() {
      var match = data.find(function (v) {
        return (!selected['1'] || v.option1 === selected['1']) &&
               (!selected['2'] || v.option2 === selected['2']) &&
               (!selected['3'] || v.option3 === selected['3']);
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = money(match.price);
      if (atc) {
        atc.disabled = !match.available;
        atc.textContent = match.available ? atc.dataset.labelAdd : atc.dataset.labelSold;
      }
      if (match.featured_media) {
        var mainImg = root.closest('.product') && root.closest('.product').querySelector('.main-media img');
        if (mainImg && match.featured_media.preview_image) mainImg.src = match.featured_media.preview_image.src;
      }
      if (history.replaceState) {
        var url = new URL(window.location);
        url.searchParams.set('variant', match.id);
        history.replaceState({}, '', url);
      }
    }
    resolve();
  });

  /* ---- Product thumbnails ---- */
  document.querySelectorAll('.product__thumbs').forEach(function (thumbs) {
    var main = thumbs.closest('.product__media').querySelector('.main-media img');
    thumbs.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      thumbs.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      b.setAttribute('aria-current', 'true');
      if (main) main.src = b.dataset.full;
    });
  });

  /* ---- Predictive search ---- */
  var sInput = document.querySelector('[data-predictive-input]');
  if (sInput && routes.predictive_search_url) {
    var box = document.querySelector('.predictive-results');
    var t;
    sInput.addEventListener('input', function () {
      clearTimeout(t);
      var q = sInput.value.trim();
      if (q.length < 2) { if (box) box.innerHTML = ''; return; }
      t = setTimeout(function () {
        fetch(routes.predictive_search_url + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var res = doc.querySelector('.predictive-results');
            if (res && box) box.innerHTML = res.innerHTML;
          }).catch(function () {});
      }, 250);
    });
  }
})();
